import { render, staticRenderFns } from "./img_laxcbjjp.vue?vue&type=template&id=40ae4025"
import script from "./img_laxcbjjp.vue?vue&type=script&lang=js"
export * from "./img_laxcbjjp.vue?vue&type=script&lang=js"
import style0 from "./img_laxcbjjp.vue?vue&type=style&index=0&id=40ae4025&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports